export const BTN_LINK_CLASSNAME =
    "btn btn-link align-text-bottom p-0 border-0 m-0";

export enum EDayEnum {
    None = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 7,
}
